export enum RecurrenceType {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY',
}

export enum DayOfWeek {
  MON = 'MON',
  TUE = 'TUE',
  WED = 'WED',
  THU = 'THU',
  FRI = 'FRI',
  SAT = 'SAT',
  SUN = 'SUN',
}

export enum EndConditionType {
  NEVER = 'NEVER',
  AFTER = 'AFTER',
  ON = 'ON',
}

export interface OneTimeSchedule {
  date?: string;
}

export interface RecurrencePattern {
  type: RecurrenceType;
  interval: number;
  daysOfWeek?: DayOfWeek[];
  dayOfMonth?: number;
}

export interface EndCondition {
  type: EndConditionType;
  occurrences?: number;
  endDate?: string;
}

export interface RecurringSchedule {
  startDate?: string;
  recurrencePattern: RecurrencePattern;
  endCondition: EndCondition;
}

export interface ScheduleDetails {
  oneTime?: OneTimeSchedule;
  recurring?: RecurringSchedule;
}

export interface AuditExpirationSettings {
  expirationEnabled: boolean;
  expirationDays?: number;
}

export interface AuditSchedule {
  scheduleId: string;
  name: string;
  description: string;
  status: string;
  isActive: boolean;
  businessUnit: string;
  program: string;
  auditType: string;
  scheduleType: string;
  scheduleDetails: ScheduleDetails;
  auditExpirationSettings: AuditExpirationSettings;
  auditTemplateIds: string[];
  nextExecutionDate: string;
  createdAt: string;
  createdBy: string;
  lastUpdatedAt: string;
  lastUpdatedBy: string;
}

export interface ListAuditSchedulesRequest {
  businessUnitId: string;
  program: string;
  auditType?: string;
  scheduleType?: string;
  isActive?: boolean;
  startDate?: string;
  endDate?: string;
  nextToken?: string;
  maxResults?: number;
  templateId?: string;
}

export interface GetAuditScheduleRequest {
  businessUnitId: string;
  scheduleId: string;
}

export interface GetAuditScheduleResponse {
  schedule: AuditSchedule;
}

export interface ListAuditSchedulesResponse {
  schedules: AuditSchedule[];
  nextToken?: string;
}

export interface CreateAuditScheduleRequest {
  name: string;
  description: string;
  isActive: boolean;
  businessUnitId: string;
  program: string;
  auditType: string;
  scheduleType: string;
  scheduleDetails: ScheduleDetails;
  auditExpirationSettings: AuditExpirationSettings;
  auditTemplateIds: string[];
  createdBy: string;
}

export interface CreateAuditScheduleResponse {
  schedule: AuditSchedule;
}

export interface UpdateAuditScheduleRequest {
  scheduleId: string;
  name?: string;
  description?: string;
  isActive?: boolean;
  businessUnitId?: string;
  program?: string;
  auditType?: string;
  scheduleType?: string;
  scheduleDetails?: ScheduleDetails;
  auditExpirationSettings?: AuditExpirationSettings;
  auditTemplateIds?: string[];
  updatedBy: string;
}

export interface UpdateAuditScheduleResponse {
  schedule: AuditSchedule;
}
